import { hellopanda_func as $ } from '../../assets/script/func.js';

/**
 * 블록 스크롤 고정
 * 블록 테마에서 설정함
 */
function hellopanda_init() {

  // 스크롤바 크기 등록
  document.documentElement.style.setProperty(
    '--scrollbar-width',
    `${window.innerWidth - document.documentElement.clientWidth}px`
  );

  let resizeSet = new Set();
  let resizeWidth = window.innerWidth;
  let resizeHeight = window.innerHeight;
  let resizeHeightAllow = $.resizeHeightAllow;

  // debounce 함수 정의
  // function debounce(func, wait) {
  //   let timeout;
  //   return function(...args) {
  //     const later = () => {
  //       clearTimeout(timeout);
  //       func(...args);
  //     };
  //     clearTimeout(timeout);
  //     timeout = setTimeout(later, wait);
  //   };
  // }

  // 스로틀링 함수 정의
  function throttle(func, delay) {
    let lastTime = 0;
    return function(...args) {
      const now = new Date().getTime();
      if (now - lastTime >= delay) {
        func.apply(this, args);
        lastTime = now;
      }
    };
  }



  // 딜레이
  function debounce (fn, delay) {

    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };

  };

  // 진짜 resize 발생 여부 확인
  function checkResize() {
    const w = window.innerWidth;
    const h = window.innerHeight;
    let changed = false;

    if (w !== resizeWidth) {
      resizeWidth = w;
      changed = true;
    } else if (Math.abs(h - resizeHeight) >= resizeHeightAllow) {
      resizeHeight = h;
      changed = true;
    }

    return changed;
  };

  // 모든 구독자에게 알림
  function resizeNotify() {
    resizeSet.forEach(fn => fn(resizeWidth, resizeHeight));
  };

  // 모듈이 리사이즈 감지에 참여할 때
  function resizeSubscribe(fn) {
    const _ = this;
    resizeSet.add(fn);
    return () => resizeSet.delete(fn);
  };



  // 스틱키 요소 정의
  const stickyElements = document.querySelectorAll('.block-sticky');
  stickyElements.forEach((element) => {

    const get_adminbar_position = () => {
      let gap = 0;
      const adminbar = document.querySelector('#wpadminbar');
      if (adminbar) {
        const elStyle = window.getComputedStyle(adminbar);
        if (elStyle.position === 'fixed') {
          gap = adminbar.getBoundingClientRect().height;
        }
      }
      return gap;
    }

    // 데이터 속성 얻기
    let scroll_gap = get_adminbar_position();
    let posTop = parseInt(element.dataset.top || 0) + scroll_gap || 0 + scroll_gap ;
    let posLeft = element.dataset.left ? parseInt(element.dataset.left) : undefined ;
    let posRight = element.dataset.right ? parseInt(element.dataset.right) : undefined ;
    let posTiming = element.dataset.stickytiming || '';

    // 래퍼(wrapper) 요소 생성
    const wrapper = document.createElement('div');
    wrapper.classList.add('block-sticky-holder');
    element.parentNode.insertBefore(wrapper, element);

    // 요소 높이를 미리 지정
    if (element.getBoundingClientRect().height) {
      wrapper.style.height = `${element.getBoundingClientRect().height}px`;
    } else {
      wrapper.style.height = ''; 
    }

    let observer;
    function setOverserver () {

      // 기존 옵저버 해제
      if (observer) {
        observer.disconnect();
      }

      // 한번 더 정의
      scroll_gap = get_adminbar_position();
      posTop = parseInt(element.dataset?.top) + scroll_gap || 0 + scroll_gap ;

      // 옵저버 컨테이너
      observer = new IntersectionObserver(
        ([entry]) => {

          // 타이밍 계산
          if (
            posTiming === 'meet' && 
            entry.boundingClientRect.width && 
            window.innerHeight > posTop + wrapper.getBoundingClientRect().height && 
            (
              (entry.boundingClientRect.width === entry.intersectionRect.width && entry.intersectionRatio < 1) || 
              (entry.intersectionRatio === 0 && posTop > wrapper.getBoundingClientRect().top)
            )
          ) {
            wrapper.style.height = `${element.getBoundingClientRect().height}px`;
            entry.target.classList.add('is-block-sticky');
            element.style.animation = undefined;
            element.style.top = `${posTop}px`;
            element.style.left = posLeft !== undefined && posLeft !== null ? `${posLeft}px` : undefined;
            element.style.right = posRight !== undefined && posRight !== null ? `${posRight}px` : undefined;
          } else if (!entry.isIntersecting && posTiming != 'meet') {
            wrapper.style.height = `${element.getBoundingClientRect().height}px`;
            entry.target.classList.add('is-block-sticky');
            element.style.top = `${posTop}px`;
            element.style.left = posLeft !== undefined && posLeft !== null ? `${posLeft}px` : undefined;
            element.style.right = posRight !== undefined && posRight !== null ? `${posRight}px` : undefined;
          } else {
            entry.target.classList.remove('is-block-sticky');
            element.style.top = '';
            element.style.left = '';
            element.style.right = '';
            wrapper.style.height = ''; 
          }

        },
        { 
          root: document,
          threshold: [0, 1],
          rootMargin: `-${posTop}px 0px -${posTop}px 0px`
        }
      );

      // 옵저버 수행
      observer.observe(wrapper);

    }

    // 자식 노드 삽입
    wrapper.appendChild(element);

    // 첫번째 옵저버 실행
    setOverserver();

    // 리사이즈 핸들러 정의
    // const handleImmediateResize = throttle(() => {
      // reRendering(wrapper, element, posTop, posLeft, posRight, posTiming);
    // }, 0); // 즉시 실행

    // 리사이즈 옵저버 업데이트 .3s
    // const handleDebouncedResize = debounce(() => {
    //   // reRendering(wrapper, element, posTop, posLeft, posRight, posTiming);
    //   setOverserver();
    // }, 300); // {x}ms 이후에 실행

    // // 리사이즈 이벤트 리스너 추가
    // window.addEventListener('resize', () => {
    //   // handleImmediateResize();
    //   handleDebouncedResize();
    //   // observer.unobserve(wrapper);
    //   // observer.observe(wrapper);
    // });

    // 구독으로 리사이즈 실행
    resizeSubscribe(() => {
      setOverserver();
    });

  });

  // 구독형 리사이즈 ( IOS 개선 )
  const handleResize = debounce(() => {
    if (checkResize()) {
      resizeNotify();
    }
  }, 300);
  window.addEventListener('resize', handleResize.bind(this));

  // 외부에서 GNB 메뉴 열기
  window.addEventListener('DOMContentLoaded', () => {
    const gnb_menu_btns = document.querySelectorAll('.header-gnb-toggle-btn');
    gnb_menu_btns.forEach(btn => {
      btn.addEventListener('click', function () {
        const header_gnb_btn = document.querySelector('.header-gnb .wp-block-navigation__responsive-container-open');
        header_gnb_btn.click();
      });
    });
  });

}
hellopanda_init();